export default from './InfoRow';



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerRequestPage/components/SurveySummary/components/InfoRow/index.js